import React from 'react';
import TrackMeApp from './TrackMeApp';

const Root: React.FC = () => <TrackMeApp />;

export default Root;